// src/components/NewsDetail.js

import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';

const NewsDetail = ({ onBack }) => {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(''); // ★エラー原因を画面に表示する箱

  useEffect(() => {
      let isMounted = true; // 画面切り替え時のエラーを防ぐ安全装置

      const fetchNews = async () => {
          try {
              // もしdb（データベース接続）が見つからなかったらエラーを出す
              if (!db) {
                  throw new Error("データベース接続が見つかりません。");
              }

              const q = query(collection(db, 'news'), orderBy('createdAt', 'desc'));
              const snap = await getDocs(q);
              
              if (isMounted) {
                  const list = snap.docs
                      .map(d => ({ id: d.id, ...d.data() }))
                      .filter(n => n.isActive === true); // 表示中のものだけを残す
                      
                  setNewsList(list);
                  setLoading(false);
              }
          } catch (e) {
              console.error("お知らせの取得に失敗しました", e);
              if (isMounted) {
                  // エラーが起きたら、真っ白にせずにエラーメッセージを画面に出す
                  setErrorMessage(e.message || "データ取得中に不明なエラーが発生しました");
                  setLoading(false);
              }
          }
      };
      
      fetchNews();
      return () => { isMounted = false; };
  }, []);

  // 日付の変換でエラーが起きても安全に回避する関数
  const getSafeDate = (dateData) => {
      if (!dateData) return '';
      try {
          const d = new Date(dateData);
          if (isNaN(d.getTime())) return '';
          return d.toLocaleDateString('ja-JP');
      } catch(e) {
          return '';
      }
  };

  return (
    <div className="container" style={{ paddingBottom: '80px' }}>
      <div className="card" style={{ borderRadius: '0 0 20px 20px', textAlign: 'center', marginBottom: '20px', marginTop:'-10px', paddingTop:'40px', position: 'relative' }}>
        <button onClick={onBack} style={{ position: 'absolute', left: '20px', top: '20px', background: 'none', border: 'none', color: '#ff9800', fontSize: '16px', padding:0, cursor: 'pointer', fontWeight: 'bold' }}>
          ← 戻る
        </button>
        <h2 style={{ margin: 0, fontSize: '20px', color: '#333' }}>お知らせ一覧</h2>
      </div>

      <div style={{ padding: '0 20px' }}>
        {loading ? (
            <div style={{ textAlign: 'center', color: '#999', padding: '40px' }}>読み込み中...</div>
        ) : errorMessage ? (
            /* ★エラーが起きた場合は、真っ白にせず赤い枠で原因を表示する */
            <div className="card" style={{ border: '2px solid red', color: 'red', padding: '20px' }}>
                <h3 style={{ marginTop: 0 }}>エラーが発生しました</h3>
                <p style={{ fontSize: '14px' }}>{errorMessage}</p>
                <p style={{ fontSize: '12px', color: '#666' }}>※もう一度トップページから開き直すか、管理者に報告してください。</p>
            </div>
        ) : newsList.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#999', padding: '40px' }}>
                現在、新しいお知らせはありません。
            </div>
        ) : (
            newsList.map((news) => (
                <div key={news.id} className="card" style={{ background: '#fff', border: `1px solid #ff9800`, marginBottom: '15px' }}>
                  <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>
                      {getSafeDate(news.createdAt)}
                  </div>
                  <h3 style={{ fontSize: '16px', color: '#ff9800', marginTop: 0, marginBottom: '15px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
                    {news.title || 'タイトルなし'}
                  </h3>
                  <div style={{ fontSize: '14px', lineHeight: '1.8', color: '#333', whiteSpace: 'pre-wrap' }}>
                    {news.content || ''}
                  </div>
                </div>
            ))
        )}
      </div>
    </div>
  );
};

export default NewsDetail;